import classNames from 'classnames';
import type { CSSProperties, PropsWithChildren } from 'react';
import * as styles from './EmptyState.css';

type Props = PropsWithChildren<{
  backgroundColor: CSSProperties['backgroundColor'];
  textColor: CSSProperties['color'];
  padding: CSSProperties['padding'];
}>;

const EmptyState = ({ backgroundColor, textColor, padding, children }: Props) => {
  return (
    <div
      style={
        {
          backgroundColor,
          color: textColor,
          padding,
        } as CSSProperties
      }
      className={classNames(styles.container)}
    >
      {children}
    </div>
  );
};

export { EmptyState };
